import angular from "angular";

angular
    .module('ui-sentinel.geofences')
    .factory('GeofencesDataService', GeofencesDataService);

GeofencesDataService.$inject = ['$rootScope', '$q', 'SentinelUiSession', 'PolygonGeofencesService', 'RadialGeofencesService', 'FeedbackService', 'localStorageService'];

function GeofencesDataService($rootScope, $q, SentinelUiSession, PolygonGeofencesService, RadialGeofencesService, FeedbackService, localStorageService) {
    const service = {
        all: [],
        radials: [],
        polygons: [],
        feedback: FeedbackService,
        load: load,
        geofenceLocationTypeAddress: 0,
        geofenceLocationTypeLatLong: 1,
    };
    activate();
    return service;

    ////////////////////////

    function activate() {

        load();
    }

    function load() {
        service.all = [];
        $rootScope.loading = true;

        const focus = SentinelUiSession.focus;

        const radialPromise = RadialGeofencesService.getGeofences(focus).$promise;
        radialPromise.then(
            function (result) {
                service.radials = [];
                _.forEach(result, function (geofence) {
                    _.remove(service.all, function (dupe) {
                        return dupe.id === geofence.id;
                    });
                    service.all.push(geofence);
                    service.radials.push(geofence);
                });
            },
            function (error) {
                service.feedback.addErrorFromError(error);
            }
        );

        const polygonPromise = PolygonGeofencesService.getGeofences(focus).$promise;
        polygonPromise.then(
            function (result) {
                service.polygons = [];
                _.forEach(result, function (geofence) {
                    _.remove(service.all, function (dupe) {
                        return dupe.id === geofence.id;
                    });
                    service.all.push(geofence);
                    service.polygons.push(geofence);
                });
            },
            function (error) {
                service.feedback.addErrorFromError(error);
            }
        );

        $q.all([radialPromise, polygonPromise]).finally(function () {
            $rootScope.loading = false;
        });
    }
}
